import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from './routes/AppRouter'
import { AuthBridge } from '../core/auth/AuthBridge'
export default function App() {
  return (
    <BrowserRouter>
      <div className="app-shell">
         <AuthBridge />
        <AppRouter />
      </div>
    </BrowserRouter>
  )
}
